export default {
    title: 'Planning settings',
    subtitle: 'Plan the timeline for your feedback cycle',
    saveSettingsSuccessTitle: 'Settings saved',
    saveSettingsSuccessMessage: 'Your schedule settings have been saved successfully',
    launchReview: {
        title: "You're all set. Activate the feedback cycle!",
        launch: 'Activate cycle',
    },
    updateReview: {
        title: "You're all set. Update the feedback cycle!",
        launch: 'Update cycle',
    },
    schedulingOptions: {
        subtitle: 'Plan your feedback cycle',
        scheduledAt: 'Start Date',
        feedbackFrequency: 'Evaluation frequency',
    },
    validation: {
        scheduledAtRequired: 'Next evaluation date is required',
        scheduledAtPastTitle: 'Cycle launch refused',
        scheduledAtPast: 'The date you chose is now in the past.',
        resetToTodayAction: 'Reset to today',
        feedbackFrequencyRequired: 'Evaluation frequency is required',
    },
    customizeSurveyEmail: {
        title: 'Customize the {{managerLabelCapitalized}} Notification Email',
    },
    launchSummary: {
        header: {
            title: 'Launch summary',
            subtitle: 'Review what will happen before launching the feedback cycle.',
        },
        frame: {
            title: 'Cycle setup',
            name: 'Name',
            period: 'Period',
            audience: 'Audience',
            audienceCount: '{{count}} employee',
            audienceCount_other: '{{count}} employees',
        },
        evaluations: {
            title: 'Included evaluations',
            none: 'No evaluations included yet.',
            noTemplate: 'No additional template',
        },
        schedule: {
            title: 'Communication schedule',
            noDate: 'Date to be defined',
            sentOn: 'Sent on {{date}}',
            willSendTo: 'Will send to: {{audiences}}',
            noEmail: 'No email for this milestone yet.',
            audienceEmployees: 'Employees',
            audienceManagers: '{{managerPluralLabelCapitalized}}',
            itemBlocking: 'This blocks the launch.',
        },
        changes: {
            title: 'Changes since the last launch',
            subtitle: 'Review what will change before applying your evaluation-cycle updates.',
            none: 'No changes since the last launch.',
            alreadyTriggered: 'Step already triggered, changes only apply to future sends.',
            applyCta: 'Apply changes',
            appliedTitle: 'Changes applied',
            appliedMessage: 'The cycle now runs on the updated configuration.',
            appliedSkippedMilestones: 'Changes applied. Overdue milestones skipped: {{count}}.',
            nameChanged: 'Name changed from <bold>{{from}}</bold> to <bold>{{to}}</bold>.',
            cycleStartChanged: 'Start date moved from {{from}} to {{to}}.',
            cycleEndChanged: 'End date moved from {{from}} to {{to}}.',
            audienceChanged: 'Audience changes from <bold>{{from}}</bold> to <bold>{{to}}</bold>.',
            audienceFiltersChanged: 'Audience filters were updated.',
            evaluationAdded:
                '<bold>{{name}}</bold> was added. Invitations will go out on {{date}}.',
            evaluationAddedNoDate:
                '<bold>{{name}}</bold> was added. The send date is still to be defined.',
            evaluationRemoved: '<bold>{{name}}</bold> was removed. No invitations will be sent.',
            templateChanged:
                'The template for <bold>{{name}}</bold> changes from <bold>{{from}}</bold> to <bold>{{to}}</bold>.',
            templateSet: 'The template for <bold>{{name}}</bold> is now <bold>{{to}}</bold>.',
            stepDateChanged: 'Step <bold>{{step}}</bold> moved from {{from}} to {{to}}.',
            stepDateChangedAbbreviated: 'Step <bold>{{step}}</bold> moved from {{from}} to {{to}}',
            emailEnabled: 'Email <bold>{{step}} → {{audience}}</bold> is now enabled.',
            commentRepliesEnabled: 'Replies to comments on <bold>{{name}}</bold> are now enabled.',
            commentRepliesDisabled:
                'Replies to comments on <bold>{{name}}</bold> are now disabled.',
            emailDisabled: 'Email <bold>{{step}} → {{audience}}</bold> is now disabled.',
            emailContentChanged:
                'Content of email <bold>{{step}} → {{audience}}</bold> was modified.',
            audienceEntireCompany: 'Entire organization',
            audienceTargeted: 'Targeted teams',
            noDate: '—',
        },
        launchReview: {
            title: "You're all set. Start the cycle!",
            updateTitle: "You're all set. Update the cycle!",
            cta: 'Start the cycle',
            note: 'This will send email notifications to all participants.',
            blockedMessage: 'Complete the flagged items before launching.',
            successTitle: 'Cycle started',
            successMessage: '{{count}} scheduled send is now armed.',
            successMessage_other: '{{count}} scheduled sends are now armed.',
        },
    },
};
